import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const defaultSettings = {
  site_name: 'MediCare Plus',
  site_tagline: 'Your Trusted Online Pharmacy Partner',
  contact_email: 'support@medicareplus.com',
  contact_phone: '+1-800-MED-CARE',
  contact_address: '',
  free_shipping_threshold: 50,
  default_shipping_cost: 5.99,
  currency: 'USD',
  currency_symbol: '$',
  tax_rate: 0,
  tax_included: true,
  logo_text: 'M+',
  site_logo: null,
  site_favicon: null,
  social_facebook: '',
  social_twitter: '',
  social_instagram: '',
  social_youtube: '',
  social_linkedin: '',
};

const SettingsContext = createContext(defaultSettings);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [homepageLayout, setHomepageLayout] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const [settingsRes, layoutRes] = await Promise.all([
          fetch(`${API_URL}/api/settings`),
          fetch(`${API_URL}/api/homepage-layout`),
        ]);
        if (settingsRes.ok) {
          const data = await settingsRes.json();
          setSettings(prev => ({ ...prev, ...data }));
        }
        if (layoutRes.ok) {
          setHomepageLayout(await layoutRes.json());
        }
      } catch (err) {
        console.error('Failed to load settings:', err);
      }
    };
    fetchSettings();
  }, []);

  // Update browser tab title and favicon when settings change
  useEffect(() => {
    if (settings.site_name) {
      document.title = `${settings.site_name} | ${settings.site_tagline || 'Online Pharmacy'}`;
    }
    // Update favicon if set
    if (settings.site_favicon) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = settings.site_favicon;
      document.head.appendChild(link);
    }
    // Update meta tags
    const descMeta = document.querySelector('meta[name="description"]');
    if (descMeta && settings.site_name) {
      descMeta.content = `${settings.site_name} - ${settings.site_tagline || 'Your trusted online pharmacy'}`;
    }
  }, [settings.site_name, settings.site_tagline, settings.site_favicon]);

  return (
    <SettingsContext.Provider value={{ ...settings, homepageLayout }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
export default SettingsContext;
